import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { InvoiceReport } from "../../../components/Reports";

export interface IInvoiceReportPage {}

export const InvoiceReportPage: FC<IInvoiceReportPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Invoice Report"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<InvoiceReport />}
    />
  );
};
